import styled from "styled-components";
import { Input } from 'antd'

export const CurrencyInput = styled(Input)`
  input.ant-input { text-align: right; }
`